import { observable, computedFrom, BindingEngine, bindable, bindingMode, autoinject } from 'aurelia-framework';
import { Contact } from '../../models/contact';
import { ContactPhone } from '../../models/contact-phone';
@autoinject()
export class ContactCard {

    static instanceCount: number=0;

    @bindable({ defaultBindingMode: bindingMode.oneWay }) index = "";
    @bindable({ defaultBindingMode: bindingMode.oneWay }) contact: Contact;
    @bindable({ defaultBindingMode: bindingMode.oneWay }) readOnly:boolean;
    @bindable({ defaultBindingMode: bindingMode.oneWay }) showMills: boolean = true;
    @bindable editFunction;

    constructor() {
        this.id = "ContactCard" + ContactCard.instanceCount++;
    }

    id: String;


    editContact(e) {
        this.editFunction && this.editFunction();
        e.stopImmediatePropagation();
        e.preventDefault();
        return false;
    }

    formatTel(phone: ContactPhone) {
        let tel = phone.number + "";
        if (phone.extension) {
            tel += ",,,,," + phone.extension
        }
        return tel;
    }
}   